import * as tslib_1 from "tslib";
import { ExpirableStorage } from './expirable-storage.abstract';
import * as i0 from "@angular/core";
var ExpirableSessionStorageService = /** @class */ (function (_super) {
    tslib_1.__extends(ExpirableSessionStorageService, _super);
    function ExpirableSessionStorageService() {
        var _this = _super.call(this) || this;
        _this.storageType = 'session';
        return _this;
    }
    ExpirableSessionStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExpirableSessionStorageService_Factory() { return new ExpirableSessionStorageService(); }, token: ExpirableSessionStorageService, providedIn: "root" });
    return ExpirableSessionStorageService;
}(ExpirableStorage));
export { ExpirableSessionStorageService };
